import React, { Fragment, useEffect, useState, useRef, useMemo } from 'react'
import PropTypes from 'prop-types'
import {
    Calendar,
    Views,
    DateLocalizer,
    dateFnsLocalizer,
} from 'react-big-calendar'
import format from 'date-fns/format'
import parse from 'date-fns/parse'
import startOfWeek from 'date-fns/startOfWeek'
import getDay from 'date-fns/getDay'
import zhTW from 'date-fns/locale/zh-TW'
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Box } from '@material-ui/core'
import useResizeObserver from '@react-hook/resize-observer'
import zIndex from '@material-ui/core/styles/zIndex'



const locales = {
    'zh-TW': zhTW,
}

const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
})

const useSize = (target) => {
    const [size, setSize] = React.useState()

    React.useLayoutEffect(() => {
        setSize(target.current.getBoundingClientRect())
    }, [target])

    const onScroll = () => {
        setSize(target.current.getBoundingClientRect())
    }

    // useEffect(() => {
    //     window.addEventListener("scroll", onScroll);
    // }, [third])


    // Where the magic happens
    useResizeObserver(target, (entry) => setSize(entry.contentRect))
    return { size, onScroll }
}


// const EventCom =  ({ event }) => (
//     <div>
//       <div>{event.title}</div>
//       <div>({event.QUOTA})</div>
//     </div>
//   );



export default function EventCalendar({
    ...props
}) {

    const containerRef = useRef(null)
    const containerSize = useSize(containerRef)
    const calendarRef = useRef(null)
    const calendarSize = useSize(calendarRef)

    // console.log(containerSize.size);
    // console.log(calendarSize.size);
    // console.log(dimensions);

    useEffect(() => {
        containerSize.onScroll()
        calendarSize.onScroll()

        // setTimeout(() => {

        //     containerSize.onScroll()
        //     calendarSize.onScroll()
        // }, 300);      
    }, [])


    const formats = useMemo(() => ({
        dateFormat: 'dd',

        weekdayFormat: (date, culture, localizer) => {
            // console.log(culture);
            return localizer.format(date, 'EEEEE', culture)
        }


    }), [])




    return (
        <Box
            width={"100%"}
            overflow="auto"
            ref={containerRef}
            onScroll={() => {
                containerSize.onScroll()
                calendarSize.onScroll()
            }}
        >

            <div style={{ height: "600px" }} ref={calendarRef}  {...props}>
                <Calendar
                    culture="zh-TW"
                    defaultDate={new Date()}
                    events={props.events}
                    localizer={localizer}
                    showAllEvents
                    step={60}
                    selectable
                    views={[Views.MONTH]}
                    messages={{ next: "下頁", previous: "上頁", today: "目前" }}
                    components={{
                        // event: EventCom,
                        // eventContainerWrapper: EventWrapCom

                    }}
                    onSelectEvent={props.onSelect}
                    eventPropGetter={(event, start, end, isSelected) => {
                        // console.log(event);
                        const style = {
                            backgroundColor: event.disabled ? "#AAA" : isSelected ? '#eb5b34' : "#34bdeb",
                            textAlign: "center"
                        }

                        return {
                            style: style
                        }
                    }}
                    selected={props.selected}
                    formats={formats}
                />
            </div>
        </Box>
    )
}
Calendar.propTypes = {
    localizer: PropTypes.instanceOf(DateLocalizer),
    showDemoLink: PropTypes.bool,
}